import type { TgLinkStatusDto } from '@ledokol/contracts'

/**
 * Эпик «UI tg-link сотрудника» (T12) P1 — pure-функция reducer для UI state machine.
 *
 * Источник истины — `GET /me/tg/link/status` (api-ручка готова с Stage 3 B5).
 * UI выводит one-of-four состояний; pure, тестируется без браузера/api.
 *
 * Состояния (см. `docs/epic-tg-profile-link-plan.md` §1.1):
 *  - 'pristine'             — ничего нет: нет кода, нет pending, не привязан.
 *  - 'code-pending-redeem'  — admin получил код, ждёт что бот его redeem'нет.
 *  - 'awaiting-confirm'     — бот redeem'нул, api поставил pending {tg_user_id, tg_username};
 *                              UI показывает «Это @username? [Подтвердить]» (защита от перехвата).
 *  - 'linked'               — закреплено, viewable «Привязано: @username [Отвязать]».
 *
 * Краевой кейс (TDD-инвариант 5): `{linked:false, has_active_code:false, pending: {...}}` —
 * аномалия данных (pending без активного кода невозможен по дизайну, но защищаемся: возвращаем
 * 'pristine' — корректное действие = начать flow с нуля, не виснуть в неконсистентном state).
 */
export type MeTgState = 'pristine' | 'code-pending-redeem' | 'awaiting-confirm' | 'linked'

export function deriveMeTgState(status: TgLinkStatusDto): MeTgState {
  if (status.linked) return 'linked'
  // Защита от аномалии: pending без has_active_code — игнорируем pending, возвращаем pristine.
  // Это закрывает edge-case если api по какой-то причине вернёт неконсистентный объект.
  if (!status.has_active_code) return 'pristine'
  if (status.pending !== null) return 'awaiting-confirm'
  return 'code-pending-redeem'
}
